export const apiEndpoint = 'https://ethioliq.com/api';
export const defaultPage = 'https://ethioliq.com';
// export const apiEndpoint = 'https://ethioliq-server.onrender.com';
// export const apiEndpoint = 'http://localhost:4000/api';
// export const defaultPage = 'http://localhost:4000';